import * as React from "react";
const SvgBurger = props => <svg width={26} height={26} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentColor" d="M0 8h26v2H0zm0 8h26v2H0z" /></svg>;
export default SvgBurger;